import type { QueryClient } from "@tanstack/react-query"
import { updateFriendInCache } from "@/entities/friend"
import type { WsVoiceMessageUpdated } from "@/shared/api/generated-social"
import { wsBridge, wsStore, wsUserId } from "@/shared/api/websocket"
import { onAppActive } from "@/shared/lib/platform"
import { applyVoiceMessage } from "../model/apply-voice-message"
import { voiceKeys } from "../model/keys"
import { hasUnheardVoice } from "../model/unheard-voice"

function syncVoiceMessages(): void {
	const { queryClient } = wsBridge.getContext()
	if (!queryClient || !wsUserId()) return
	queryClient.refetchQueries({ queryKey: voiceKeys.messages(), type: "active" })
}

function handleVoiceMessageUpdated(
	payload: WsVoiceMessageUpdated,
	queryClient: QueryClient,
): void {
	const voiceMessage = payload.message
	applyVoiceMessage(queryClient, payload.friend_id, voiceMessage)

	const userId = wsUserId()
	if (!userId || !hasUnheardVoice(voiceMessage, payload.friend_id)) return
	updateFriendInCache(queryClient, userId, payload.friend_id, (friend) => ({
		...friend,
		unread_board: true,
	}))
}

export function registerVoiceEvents(): void {
	wsStore.on("state", ({ isConnected }) => {
		if (isConnected) syncVoiceMessages()
	})
	onAppActive(syncVoiceMessages)
	wsBridge.subscribe("voice.message.updated", handleVoiceMessageUpdated)
}
